import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { usePopperContentProps } from '@sgui-plus/components/popper'
import { useDelayedToggleProps } from '@sgui-plus/hooks'
import type TooltipContent from './content.vue'
import type { ExtractPropTypes } from 'vue'

type ClassObjectType = Record<string, any>
type ClassType = string | ClassObjectType | ClassType[]

export const useTooltipContentProps = buildProps({
  ...useDelayedToggleProps,
  ...usePopperContentProps,
  appendTo: {
    type: definePropType<string | HTMLElement>([String, Object])
  },
  content: {
    type: String,
    default: '',
  },
  rawContent: {
    type: Boolean,
    default: false,
  },
  persistent: Boolean,
  ariaLabel: String,
  // because model toggle prop is generated dynamically
  // so the typing cannot be evaluated by typescript as type:
  // [name]: { type: Boolean, default: null }
  // so we need to declare that again for type checking.
  visible: {
    type: definePropType<boolean | null>(Boolean),
    default: null,
  },
  transition: {
    type: String,
    default: 'sg-fade-in-linear',
  },
  transfer: {
    type: Boolean,
    default: true,
  },
  disabled: Boolean,
  maxWidth: {
    type: [String, Number],
    default: ''
  },
  dropClassName: {
    type: definePropType<ClassType>([String, Array, Object]),
  },
  maxLength: {
    type: Number,
    default: 2000
  },
  theme: {
    type: String,
    default: 'dark',
  },
  autoHide: {
    type: Boolean,
    default: false
  },
  // 气泡内容是以 v-if 的方式显示，还是 v-show 的方式显示，默认 v-if
  renderContentType: {
    type: String,
    values: ['if', 'show'],
    default: 'if'
  }
} as const)

export type SgTooltipContentProps = ExtractPropTypes<
  typeof useTooltipContentProps
>

export type TooltipContentInstance = InstanceType<typeof TooltipContent>

